import { ChangeEvent, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, Input } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

import {
	InputContainerStyled,
	RequestConsultationHeaderStyled,
	RequestConsultationStyled,
	RequestConsultationTextStyled,
} from 'features/tariffs/request-consultation/ui/RequestConsultation/RequestConsultation.styles';
import { isValidEmailAddress } from 'shared/lib/isValidEmailAddress';
import { InputErrorMessage } from 'shared/ui/InputErrorMessage';
import { MpLink } from 'shared/ui/MpLink';

interface Props {
	email: string;
	updateEmail: (newEmail: string) => void;
	handleCheckboxChange: (e: CheckboxChangeEvent) => void;
}

export const RequestHelpFree: FC<Props> = ({ email, updateEmail, handleCheckboxChange }) => {
	const { t } = useTranslation();

	const onEmailChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
		updateEmail(e.target.value);
		if (isValidEmailAddress(e.target.value)) {
			updateEmail(e.target.value);
		}
	};

	return (
		<RequestConsultationStyled>
			<RequestConsultationHeaderStyled>
				{t(`Marketplace_Access_To_Konsol_Heading`)}
			</RequestConsultationHeaderStyled>
			<RequestConsultationTextStyled>{t(`Marketplace_Access_To_Konsol_Text`)}</RequestConsultationTextStyled>
			<InputContainerStyled>
				<Input
					type='email'
					placeholder={t(`Marketplace_Your_Email`) ?? ``}
					onChange={onEmailChange}
					status={!isValidEmailAddress(email) && !!email.length ? `error` : ``}
					value={email}
					style={{ padding: `16px`, fontSize: `16px`, borderRadius: `8px` }}
				/>
				{!isValidEmailAddress(email) && !!email.length && (
					<InputErrorMessage>{t(`Marketplace_Invalid_Email`)}</InputErrorMessage>
				)}
			</InputContainerStyled>
			<Checkbox onChange={handleCheckboxChange} style={{ marginBottom: `8px` }}>
				{t(`Marketplace_Accept_Email_Transfer`)}
				<MpLink url='https://konsol.pro/' text='«Konsol.Pro»' />
			</Checkbox>
		</RequestConsultationStyled>
	);
};
